import { render, staticRenderFns } from "./InfoNei.vue?vue&type=template&id=32847456&scoped=true"
import script from "./InfoNei.vue?vue&type=script&lang=js"
export * from "./InfoNei.vue?vue&type=script&lang=js"
import style0 from "./InfoNei.vue?vue&type=style&index=0&id=32847456&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32847456",
  null
  
)

export default component.exports